import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducers/auth";
import alertReducer from "../reducers/alerts";
import uniquePartsForClassifierReducer from "../reducers/uniquePartsForClassifier";
import uploadedBoard from "../reducers/uploadedBoard";
import componentSearchReducer from "../reducers/componentSearch";
import selectPartFiltersReducer from "../reducers/selectPartFilters";
import shoppingCartOrder from "../reducers/shoppingCartOrder";
import flagsReducer from "../reducers/flags";
import modalsReducer from "../reducers/modals";
import svgViewerReducer from "../reducers/svgViewer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alerts: alertReducer,
    uniquePartsForClassifier: uniquePartsForClassifierReducer,
    uploadedBoard: uploadedBoard,
    shoppingCartOrder: shoppingCartOrder,
    componentSearch: componentSearchReducer,
    selectPartFilters: selectPartFiltersReducer,
    flags: flagsReducer,
    modals: modalsReducer,
    svgViewer: svgViewerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { ignoredPaths: ["parts.parts"] },
      serializableCheck: { ignoredPaths: ["parts.parts"] },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
